import WebinarListPage from "@/containers/WebinarListPage";
import { renderMetaData } from "@/utils";
//Redux
import { wrapper } from "@/redux/Store";
import * as dashboardActions from "@/redux/DashboardReducer";
import * as WebinarActions from "@/redux/WebinarReducer";

const WebinarPage = () => {
  const metaData = {
    siteName: "Shyft",
    siteURL: "https://www.betheshyft.com/webinars",
    title:
      "Webinars by health experts - doctors, nutritionists, coaches | Shyft health",
    description:
      "Webinars by health experts on different topics in everyday and chronic health - hear it directly from doctors, nutritionists, coaches",
    thumbnail: "https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/logo-c305d1c2dc6e4a9cb2d7767c4d9c213b.png",
  };

  const metaTags = renderMetaData(metaData);

  return (
    <>
      {metaTags}
      <main>
        <h1 style={{ display: "none" }}>Webinars on Health by experts</h1>
        <WebinarListPage />
      </main>
    </>
  );
};

export default WebinarPage;

export const getServerSideProps = wrapper.getServerSideProps(
  (store) => async () => {
    await store.dispatch(
      dashboardActions.getRibbonData({ pathname: "webinars" })
    );

    await store.dispatch(
      WebinarActions.getWebinarListData({ slug: `v2/webinars` })
    );
  }
);
